import isNumeric from 'validator/es/lib/isNumeric';
import { findMatch, removeEmpty, stringToCheck } from '@/utils/resultsHelper';
import { findFormFieldByName } from '../state/state';
import formFieldTypes, { includesFieldType } from '../constants';

const formObjectSummaryFields = ({ fields, summary }) => {
  const validFields = fields.filter((f) => !includesFieldType([formFieldTypes.LABEL], f.type));
  const summaryFields = removeEmpty((summary || []).map((f) => findMatch(fields, f, 'name')));

  return summaryFields.length > 0 ? summaryFields : validFields.slice(0, 2);
};

export const formObjectSummaryKeys = (field, item, prefix = '') => {
  const fields = formObjectSummaryFields(field);
  const values = removeEmpty(fields.map((f) => item[f.name])).map((v) => String(v).toLowerCase().slice(0, 10));
  return `${prefix}${values.join('_')}`;
};

export const allowFormObjectAddOrRemove = ({ field }, items, disabled = false) => {
  const props = { allowAdd: !disabled, allowRemove: !disabled };
  if (disabled) return props;

  const { length } = removeEmpty(items);
  const validation = field?.validation || {};
  const min = isNumeric(stringToCheck(validation.minimum)) ? validation.minimum : 0;
  props.allowRemove = length > min;
  props.allowAdd = isNumeric(stringToCheck(validation.maximum)) ? length < validation.maximum : true;

  return props;
};

export const formObjectFieldsState = ({ sections }, { activeIndex, activeFieldName, items }) => {
  const field = findFormFieldByName({ sections }, activeFieldName);
  const [textField] = field?.fields ? formObjectSummaryFields(field) : [{ name: '' }];

  return (
    {
      ...allowFormObjectAddOrRemove({ field }, items),
      field,
      item: items[activeIndex],
      textField: textField.name,
    }
  );
};

export default formObjectSummaryFields;
